<style scoped>
.preview-static {
  padding-bottom: 100px;
  position: relative;
  width: 100%;
  margin: 20px 0 30px;
  @media (min-width: 1000px) {
    margin: 50px auto;
    width: calc(100% - 400px);
    max-width: 1000px;
  }
}

.preview-static--copy {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
}
@media (min-width: 1000px) {
  .preview-static--copy {
    margin-bottom: 80px;
    flex-direction: row;
    align-items: center;
  }
  .preview-static--copy > :last-child {
    flex: 1;
    margin: 0 auto;
    border-left: 1px solid #c2c2c2;
    padding-left: 40px;
  }
}

.screenshot-thumbnails {
  display: none;
}
@media (min-width: 1000px) {
  .screenshot-thumbnails {
    display: block;
    flex: 0 0 200px;
    padding-right: 50px;
  }
}

.screenshot-card {
  text-align: center;
  width: 100%;
  max-height: 200px;
  overflow: hidden;
  padding: 0 4px;
  margin-bottom: 10px;
}

.screenshot-wrapper {
  display: flex;
  margin-bottom: 30px;
}

.preview-header {
  text-align: center;
  flex: 1 1 0;
}

.preview-text {
  font-size: 16px;
  font-weight: normal;
}

.template-card {
  text-align: center;
  margin-bottom: 50px;
  padding: 20px;
  width: 100%;
  position: relative;
}
</style>

<template>
  <div>
    <div v-if="hasScreenshots && !isEditingToolsVisible" class="preview-static">
      <!-- Template Copy Section -->
      <div v-if="activeTemplate.copy" class="preview-static--copy">
        <div class="preview-header">
          <h1>{{ activeTemplate.copy.header[0] }}</h1>
          <p class="preview-text">{{ activeTemplate.copy.header[1] }}</p>
        </div>
        <div>
          <p v-for="(item, index) in activeTemplate.copy.pitch" :key="index">
            <span v-html="item"></span>
          </p>
          <h4>{{ activeTemplate.copy.cta }}</h4>
        </div>
      </div>

      <!-- Toolbar Section -->
      <div class="screenshot-wrapper">
        <div class="screenshot-thumbnails"></div>
        <div style="display: flex; width: 100%; gap: 20px;">
          <TemplateToolbar :downloadOptions="activeTemplate.copy && activeTemplate.copy.downloadOptions" />
          <SupportBtn/>
        </div>
      </div>

      <!-- Screenshots Section -->
      <div v-if="hasScreenshots" style="display: flex;">
        <div class="screenshot-thumbnails">
          <div v-for="(screenshotFileName, index) in activeTemplate.screenshotFileNames" :key="screenshotFileName">
            <div style="font-size: 10px; font-weight: bold; margin-bottom: 3px;">
              {{ index + 1 }}. {{ translate(getSectionForScreenshotTitle(screenshotFileName)) }}
            </div>
            <v-card outlined class="screenshot-card">
              <img src="/img/google_sheets_head.png" style="width: 110%;" />
              <img :src="screenshotSrc(screenshotFileName)" style="width: 100%; border: 1px solid #eee; margin-top: -10px;" />
            </v-card>
          </div>
        </div>

        <div>
          <div v-for="screenshotFileName in activeTemplate.screenshotFileNames" :key="screenshotFileName" style="display: flex;">
            <v-card elevation="3" class="template-card">
              <img src="/img/google_sheets_head.png" style="width: 100%;" />
              <img :src="screenshotSrc(screenshotFileName)" style="width: 100%; border: 1px solid #eee;" />
              <TemplatePreviewHighlight :previewModule="getSectionForScreenshot(screenshotFileName)" />
            </v-card>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <TemplatePreviewModules />
    </div>
  </div>
</template>

<script>
import Mixin from '@/mixins/mixin';
import TemplatePreviewModules from '@/pages/Template/TemplatePreviewModules.vue';
import TemplatePreviewHighlight from '@/pages/Template/TemplatePreviewHighlight';
import TemplateToolbar from '@/pages/Template/TemplateToolbar';
import SupportBtn from '@/SupportBtn.vue';

export default {
  name: 'TemplatePreviewStatic',
  components: {
    SupportBtn,
    TemplatePreviewModules,
    TemplatePreviewHighlight,
    TemplateToolbar,
  },
  mixins: [Mixin],
  data: () => ({
    sectionMapper: {
      Cover: 'module_cover',
      Content: 'module_content',
      Inputs: 'module_assumptions',
      Revenue: 'module_revenue',
      COS: 'module_cos',
      SGA: 'module_sga',
      WC: 'module_wc',
      CapEx: 'module_fixedassets',
      Funding: 'module_financing',
      IS: 'module_is',
      BS: 'module_bs',
      CF: 'module_cf',
      InvPerf: 'module_ip',
      CHARTS: 'module_charts',
      CH_DATA: 'module_chartsdata',
    },
  }),
  computed: {
    activeTemplate() {
      return this.$store.state.activeTemplate;
    },
    hasScreenshots() {
      return !!this.activeTemplate.screenshotFileNames;
    },
    isEditingToolsVisible() {
      return this.$store.state.isEditingToolsVisible;
    },
  },
  methods: {
    screenshotSrc(screenshotFileName) {
      const templateId = window.location.pathname.split('/').pop();
      return this.getScreenshotSrc(templateId, screenshotFileName);
    },
    getSectionForScreenshot(screenshotFileName) {
      const screenshotFileNameSheetId = screenshotFileName.split('-')[2];
      const mappedPreviewModuleId = this.sectionMapper[screenshotFileNameSheetId];
      return this.$store.state.activeTemplate.data.modules.find((module) => module.id === mappedPreviewModuleId);
    },
    getSectionForScreenshotTitle(screenshotFileName) {
      const moduleId = this.getSectionForScreenshot(screenshotFileName)?.id;
      return moduleId ? this.translate(moduleId) : screenshotFileName;
    },
  },
};
</script>
